import React from "react";
import { FormControl } from "react-bootstrap";
import { faCaretDown } from "../../../../../helpers/icons/fontAwesomeIcons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import classes from "./FeatureSelector.module.scss";

const FeatureSelector = ({
  t,
  items,
  loading,
  selectedValue,
  onChange,
  valueField,
  labelField,
  placeholderKey,
  icon,
  maxWidth,
  className,
}) => {
  return (
    <div
      className={`${classes["feature-selector-container"]} ${className || ""}`}
    >
      {icon && (
        <span className={classes.selectorIcon}>
          <FontAwesomeIcon icon={icon} />
        </span>
      )}
      <FormControl
        as="select"
        value={selectedValue || ""}
        onChange={(e) => onChange(e.target.value)}
        className={classes["feature-selector"]}
        disabled={loading}
      >
        <option value="">{t(placeholderKey || "select")}</option>
        {items &&
          items.map((item) => (
            <option key={item[valueField]} value={item[valueField]}>
              {item[labelField]}
            </option>
          ))}
      </FormControl>
    </div>
  );
};

FeatureSelector.propTypes = {
  t: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  valueField: PropTypes.string,
  labelField: PropTypes.string,
  placeholderKey: PropTypes.string,
  icon: PropTypes.object,
  maxWidth: PropTypes.string,
};
FeatureSelector.defaultProps = {
  loading: false,
  selectedValue: "",
  valueField: "_id",
  labelField: "name",
  placeholderKey: "select",
  icon: faCaretDown,
  maxWidth: "150px",
};

export default FeatureSelector;
